export default __webpack_public_path__ + "static/media/sentence.1cc9fbc3.webp";